import './styles/graphic.scss';

export default function (props, container, isMobile, data) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;


  const whoMap = {
    MC: 'Matthew Chance',
    NPW: 'Nick Paton Walsh',
    FC: 'Fact check:',
  };

  const points = container.append('div')
    .attr('class', 'points');

  data.forEach((point, index, array) => {
    const pointContainer = points.append('div')
      .attr('class', `point-container con-${point.class}`);

    if (point.number) {
      pointContainer.append('div')
        .attr('class', 'point-number')
        .html(point.number);
    }


    if (point.class === 'analysis') {
      const analysisContainer = pointContainer.append('div')
        .attr('class', 'analysis');

      if (point.who) {
        analysisContainer.append('div')
          .attr('class', `analysis-author ${point.who}`)
          .html(whoMap[point.who]);
      }

      analysisContainer.append('div')
        .attr('class', 'analysis-text')
        .html((point.text).replace(/\n/g, '<br><br>'));
    } else {
      pointContainer.append('p')
        .attr('class', point.class)
        .html(point.text);
    }

    if (data[index + 1] && data[index + 1].class !== 'analysis') {
      pointContainer.append('div')
        .attr('class', 'point-divider');
    }
  });
}
